import { Component, Vue } from 'vue-property-decorator';
import categoryThirdLevelModule from '@/store/modules/category-third-level.module'
import { CategoryThirdLevel } from '@/shared/dtos/category-third-level';
import DxDataGrid, { DxLookup, DxSelection, DxPaging, DxHeaderFilter, DxEditing, DxColumn, DxFilterRow, DxFilterPanel, DxExport, DxColumnChooser } from 'devextreme-vue/data-grid';
import categorySecondLevelModule from '@/store/modules/category-second-level.module';
import { itiMessageService } from '@/iti-core-vue';



@Component({
    components: {
        DxDataGrid,
        DxSelection,
        DxPaging,
        DxHeaderFilter,
        DxEditing,
        DxColumn,
        DxFilterRow,
        DxFilterPanel,
        DxExport,
        DxColumnChooser,
        DxLookup
    },
})

export default class CategoryThirdLevelLista extends Vue {

    public pageSize: number = 15;
    public maxWidth: number = 500;
    public addHidden = true;
    public loading = false;
    public search = '';
    public categoryThirdLevelCode: CategoryThirdLevel = new CategoryThirdLevel();

    public get categoryThirdLevelList() {
        return categoryThirdLevelModule.categories;
    }

    public get categorySecondLevelList() {
        return categorySecondLevelModule.categories;
    }

    public get columns() {
        return [
            { dataField: 'id', allowEditing: false },
            { dataField: 'code', caption: this.$tc('maestro-configuracion.codigo'), allowEditing: true },
            { dataField: 'description', caption: this.$tc('maestro-configuracion.descripcion'), allowEditing: true },
            {
                dataField: 'categorySecondLevel.id', caption: this.$tc('maestro-configuracion.categoria-segundo-nivel'),
                lookup: {
                    dataSource: this.categorySecondLevelList,
                    valueExpr: 'id',
                    displayExpr: 'code'
                }
            },
            { dataField: 'externalID', caption: this.$tc('maestro-configuracion.externalID'), allowEditing: false },
        ]
    }

    public async mounted() {
        await categoryThirdLevelModule.getCategoriesThirdLevel();
        await categorySecondLevelModule.getCategoriesSecondLevel();
    }

    public async rowInserted(e: any) {
        if (e.data.categorySecondLevel == undefined || e.data.categorySecondLevel == null || e.data.categorySecondLevel.id < 1) {
            await categoryThirdLevelModule.getCategoriesThirdLevel();
            itiMessageService.toast(this.$tc('mensajes.error-categoria-padre-vacia'), 'error', 2000);
        }
        else
            categoryThirdLevelModule.insertarCategoryThirdLevel(e.data);
    }

    public async rowUpdated(e: any) {
        if (e.data.categorySecondLevel == undefined || e.data.categorySecondLevel == null || e.data.categorySecondLevel.id < 1) {
            await categoryThirdLevelModule.getCategoriesThirdLevel();
            itiMessageService.toast(this.$tc('mensajes.error-categoria-padre-vacia'), 'error', 2000);
        }
        else
        categoryThirdLevelModule.modificarCategoryThirdLevel(e.data);
    }

    public rowRemoved(e: any) {
        categoryThirdLevelModule.eliminarCategoryThirdLevel(e.key);
    }

    public initNewRow(e: any) {
        e.data.id = 0;
    }
}